module.exports = __webpack_public_path__ + "29057b416a6da2f9f24a08925dd7b0e6.png";